// extracted by mini-css-extract-plugin
export default {"fetchingIndicator":"LoadingSpinnerInfo-styles__fetchingIndicator___kFRGb","isLoading":"LoadingSpinnerInfo-styles__isLoading___Jcvlx"};